var MiddleTNZipCodes = ['37705','37710','37716','37769','37830','37701','37737','37777','37801','37803','37804','37853','37882','37886','37015','37035','37082','37143','37146','37715','37724','37752','37825','37870','37879','37713','37722','37727','37753','37821','37843','37013','37072','37076','37080','37115','37138','37189','37201','37203','37204','37205','37206','37207','37208','37209','37210','37211','37212','37213','37214','37215','37216','37217','37218','37219','37220','37221','37228','37232','37234','37235','37236','37238','37240','37241','37242','37243','37246','37250','37029','37036','37051','37055','37181','37187','37708','37709','37861','37881','37888','37025','37033','37098','37137','37140','38454','37725','37760','37820','37871','37890','37721','37754','37806','37849','37902','37909','37912','37914','37915','37916','37917','37918','37919','37920','37921','37922','37923','37924','37929','37931','37932','37934','37938','37995','37996','37997','37998','37742','37771','37772','37774','37846','37019','37034','37047','37091','37174','38401','38451','38461','38474','38482','38487','37748','37763','37840','37854','37010','37032','37049','37073','37141','37172','37188','37037','37060','37085','37086','37089','37118','37127','37128','37129','37130','37131','37132','37153','37167','37738','37764','37862','37863','37865','37876','37022','37031','37048','37066','37075','37148','37186','37074','37014','37027','37046','37062','37064','37067','37069','37135','37179','37087','37090','37122','37184','42120','42153','42164','42202','42206','42256','42265','42276','42134','42135','42204','42216','42220','42234','42280','42286'];
var localZips = ['37643','37658','37687','37694','37616','37641','37743','37745','37810','37818','37813','37814','37860','37877','37891','37869','37642','37645','37711','37731','37811','37857','37873','37640','37683','37688','37691','37617','37618','37620','37660','37663','37664','37665','37669','37686','37699','37650','37657','37692','37601','37604','37615','37656','37659','37681','37690','28615','28617','28626','28629','28631','28640','28643','28672','28684','28693','28694','28604','28616','28622','28646','28652','28653','28657','28662','28664','28701','28704','28709','28711','28715','28728','28730','28748','28757','28770','28776','28778','28787','28801','28802','28803','28804','28805','28806','28810','28813','28814','28815','28816','28612','28619','28628','28637','28641','28647','28655','28666','28671','28680','28690','28611','28630','28633','28638','28645','28661','28667','28737','28749','28752','28761','28762','28705','28765','28777','28605','28607','28608','28618','28679','28691','28692','28698','28714','28740','28755','24292','24326','24330','24348','24363','24378','24218','24221','24243','24248','24263','24265','24277','24281','24282','24224','24225','24237','24260','24266','24280','24649','24244','24245','24250','24251','24258','24271','24290','24311','24319','24354','24370','24375','24202','24210','24211','24212','24236','24270','24327','24340','24361','24215','24216','24219','24230','24246','24279','24283','24293'];

var recommender = $('#recommender'),
    inputs = $('#recommender input'),
    zipBox = $('#recommender').find('#filterZip');

inputs.on('change', function() {
    gatherFilters();
});
zipBox.on('input', function() {
    gatherFilters();
});

if (recommender.length > 0) {
    gatherFilters();
}

$('#zip-reset-btn').on('click', function() {
    $('#recommender').find('.zip-input').removeClass('d-none');
    $('#recommender').find('.zip-reset').addClass('d-none');
    $('#recommender').find('.invalid-zip').addClass('d-none');
    $('#recommender').find('.no-zip-hidden').addClass('d-none');
    zipBox[0].value = '';
    zipBox[0].focus();
});

function gatherFilters() {
    var age = $('#recommender').find('#ageYes'),
        amt1 = $('#recommender').find('#amount1'),
        amt2 = $('#recommender').find('#amount2'),
        amt3 = $('#recommender').find('#amount3'),
        zipLength = zipBox[0].value.length;

    if(zipLength === 5) {
        $('#recommender').find('.zip-input').addClass('d-none');
        $('#recommender').find('.zip-reset').removeClass('d-none');
        if(localZips.indexOf(zipBox[0].value.trim()) > -1) {
            $('#recommender').find('.no-zip-hidden').removeClass('d-none');
            $('#recommender').find('.invalid-zip').addClass('d-none');
            $('#recommender .card-package').each(function() {
                $(this).find('.base-features').removeClass('d-none');
                $(this).find('.midtn-features').addClass('d-none');
            });
        } else if(MiddleTNZipCodes.indexOf(zipBox[0].value.trim()) > -1) {
            $('#recommender').find('.no-zip-hidden').removeClass('d-none');
            $('#recommender').find('.invalid-zip').addClass('d-none');
            $('#recommender .card-package').each(function() {
                $(this).find('.base-features').addClass('d-none');
                $(this).find('.midtn-features').removeClass('d-none');
            });
        } else {
            $('#recommender').find('.invalid-zip').removeClass('d-none');
            $('#recommender').find('.no-zip-hidden').addClass('d-none');
        }
    }


    $('#recommender').find('#package1').removeClass('is-featured');
    $('#recommender').find('#package2').removeClass('is-featured');
    $('#recommender').find('#package3').removeClass('is-featured');
    $('#recommender').find('#package4').removeClass('is-featured');

    if (amt1[0].checked) {
        if (!age[0].checked) {
            $('#recommender').find('#package1').addClass('is-featured');
        }
    }
    if (amt2[0].checked) {
        $('#recommender').find('#package2').addClass('is-featured');
        if (!age[0].checked) {
            $('#recommender').find('#package1').addClass('is-featured');
        }
    }
    if (amt3[0].checked) {
        $('#recommender').find('#package2').addClass('is-featured');
        $('#recommender').find('#package3').addClass('is-featured');
    }
    if (age[0].checked) {
        $('#recommender').find('#package4').addClass('is-featured');
    }

    // if(localZips.indexOf(zipBox[0].value.trim()) > -1) {
    //     $('#recommender .card-package').each(function() {
    //         $(this).find('.base-features').removeClass('d-none');
    //         $(this).find('.midtn-features').addClass('d-none');
    //     });
    // } else {
    //     $('#recommender .card-package').each(function() {
    //         $(this).find('.base-features').addClass('d-none');
    //         $(this).find('.midtn-features').removeClass('d-none');
    //     });
    // }

    // if (MiddleTNZipCodes.indexOf(zipBox[0].value.trim()) > -1) {
    //     $('#recommender .card-package').each(function() {
    //         $(this).find('.base-features').addClass('d-none');
    //         $(this).find('.midtn-features').removeClass('d-none');
    //     });
    // } else {
    //     $('#recommender .card-package').each(function() {
    //         $(this).find('.base-features').removeClass('d-none');
    //         $(this).find('.midtn-features').addClass('d-none');
    //     });
    // }
}